<div class="row">
  <div class="col-lg-4 mb-5 risk-ratings">
    <h3 class="sub-title mb-4">
      IVT Overall Risk
    </h3>
    <ng-container *ngIf='!isFreemium'>
      <risk-heat-bar [risk]='data?.permissions?.overallIvtPermissionRisk'></risk-heat-bar>
    </ng-container>
    <ng-container *ngIf='isFreemium'>
      <div class="freemium-lock">
        <i class="fa fa-lock"></i>
      </div>
    </ng-container>
  </div>
  <div class="col-lg-8 d-flex align-self-end justify-content-center justify-content-md-end">
    <div class="options-toolbar" *ngIf="hasDangerousPermissions">
      <div class="mr-2">Google Protection Level:</div>
      <div>
        <div aria-label="Basic example" class="btn-group toggle-filter" role="group">
          <button class="btn btn-secondary" type="button" [ngClass]="{'active': showDangerous}"
            (click)="showDangerousClick(true)">Dangerous</button>
          <button class="btn btn-secondary" type="button" [ngClass]="{'active': !showDangerous}"
            (click)="showDangerousClick(false)">All</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-lg-12">
    <div class="container-fluid px-0 info-list has-info-icon">
      <div class="tables-cont">
        <div class="table-headers">
          <div class="d-flex flex-column flex-sm-row">
            <div class="name">
              Permissions
            </div>
            <div class="description text-left">
              Description
            </div>
          </div>
          <div class="effects tooltip-info">
            <a class="">
              IVT Risk
              <i class="fa fa-info-circle"></i>
              <div class="tooltip-cont" [innerHTML]="googleProtectionTooltip"></div>
            </a>
          </div>
        </div>
        <div class="table-data" *ngFor="let permission of allPermissions"
          [ngClass]="{'dangerous': permission?.isDangerous || permission?.effects?.includes('Privacy')}">
          <div class="d-flex flex-column flex-lg-row w-75">
            <div class="name">
              <i data-placement="top" data-toggle="tooltip" enTooltip title="Google Dangerous Permission"
                class="fa fa-exclamation-circle mr-1"
                *ngIf="permission?.isDangerous || permission?.effects?.includes('Privacy')"></i>
              {{permission?.name}}
            </div>
            <div class="description">{{permission?.description}}</div>
          </div>
          <div class="effects">
            <div class="value text-capitalize">
              <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                <risk-heat-meter [risk]='permission?.ivtPermissionRisk'></risk-heat-meter>
              </ng-container>
              <div class="freemium-lock" *ngIf="isFreemium && !isFollowing">
                <i class="fa fa-lock"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-follow-unlock label="Permission IVT Risk" isBlock="true" (followClick)="follow()"
  *ngIf="!isFollowing && isFreemium"></app-follow-unlock>
